<template>
    <div
        class="DropdownSelectOption"
        :class="{'DropdownSelectOption--disabled': disabled}"
        @click="onClick"
    >
        <slot />
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    export default defineComponent({
        name: 'DropdownSelectOption',
        props: {
            disabled: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
        },
        emits: [ 'click' ],
        methods: {
            onClick(): void {
                this.$emit('click');
            },
        },
    });
</script>
